export interface SubmitResponse {
  readonly success: boolean;
  readonly messages?: Message[];
  readonly traceId: string|undefined;
  readonly correlationId: string|undefined;
  status: SubmitStatus;
  fileProgress: number;
  dataProgress: number[];
}

export interface Message {
  readonly id: string;
  readonly message: string;
}

export enum SubmitStatus {
  VALIDATING,
  GET_UPLOAD_URL,
  READ_LOCAL_FILES,
  UPLOAD_TO_S3,
  SUBMIT_FORM,
  FORM_SUBMITTED,
  UPLOADS_FAILED,
  FORM_SUBMISSION_FAILED,
}
